import { createSlice } from "@reduxjs/toolkit"

const initialStateFiltrosLiquidaciones= {
  nroSiniestro:"",
  caratula: "",
  expediente:"", 
  idJuicio:"",
  cargados:false,
  filtroRapido:""
}

export const filtrosLiquidacionesSlice = createSlice({ 
  name: "filtrosLiquidaciones", 
  initialState: initialStateFiltrosLiquidaciones, 
  reducers:{
    addFiltrosLiquidaciones: (state, action)=>{
      const {nroSiniestro,caratula,expediente,idJuicio} = action.payload
      state.nroSiniestro=nroSiniestro
      state.caratula=caratula
      state.expediente=expediente
      state.idJuicio=idJuicio
    },
    resetFiltrosLiquidaciones: (state) => {
      state.nroSiniestro = initialStateFiltrosLiquidaciones.nroSiniestro
      state.expediente = initialStateFiltrosLiquidaciones.expediente
      state.idJuicio = initialStateFiltrosLiquidaciones.idJuicio
      state.caratula = initialStateFiltrosLiquidaciones.caratula
      state.cargados = initialStateFiltrosLiquidaciones.cargados
      state.filtroRapido = initialStateFiltrosLiquidaciones.filtroRapido
    }, 
    setFiltrosCargados: (state, action) => {
      state.cargados = action.payload
    },
    addFiltroRapidoLiquidaciones: (state, action) => {
      state.filtroRapido = action.payload
    },
  }
});

export const {addFiltrosLiquidaciones, resetFiltrosLiquidaciones, setFiltrosCargados, addFiltroRapidoLiquidaciones} = filtrosLiquidacionesSlice.actions
export default filtrosLiquidacionesSlice.reducer
